module.exports = __webpack_public_path__ + "static/media/gridView.e2be10a1.svg";